import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import RefreshIcon from '@mui/icons-material/Refresh';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import {
  TextInput, useNotify, useRecordContext, useRefresh, useUpdate,
} from 'react-admin';
import { useFormContext, useWatch } from 'react-hook-form';

import { authHttpClient } from '@/Auth/authProvider';
import SpotifyIcon from '@/icons/SpotifyIcon.svg';

function AlbumSpotifySection() {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();
  const { getValues } = useFormContext();
  const [update] = useUpdate();
  const [loading, setLoading] = useState(false);
  const spotifyUrl = useWatch({ name: 'SpotifyUrl' });

  const handleForceRefresh = async () => {
    if (!record?.DiscographyAlbumIdentifier) {
      notify('No album ID found', { type: 'error' });
      return;
    }

    setLoading(true);
    try {
      const formValues = getValues();
      await update(
        'albums',
        { id: record.DiscographyAlbumIdentifier, data: formValues },
        { returnPromise: true },
      );

      const url = `/api/admin/discography/albums/${record.DiscographyAlbumIdentifier}/sync-spotify`;

      await authHttpClient(url, {
        method: 'POST',
      });

      notify('Spotify sync completed successfully', { type: 'success' });
      refresh();
    } catch (error) {
      console.error('Error syncing with Spotify:', error);
      notify('Failed to sync with Spotify', { type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleOpenSpotify = () => {
    const currentSpotifyUrl = getValues().SpotifyUrl;

    if (!currentSpotifyUrl) {
      notify('No Spotify URL available', { type: 'warning' });
      return;
    }
    window.open(currentSpotifyUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <Box
      mb={3} width={{ xs: '100%', md: '70%' }}
      p={2} border={1}
      borderRadius={2} borderColor='grey.400'
    >
      <Typography
        variant='h6' gutterBottom
        display='flex' alignItems='center'
        gap={1}
      >
        <img
          src={SpotifyIcon}
          alt='Spotify'
          style={{ width: 24, height: 24 }}
        />
        Spotify
      </Typography>

      <Box
        display='flex' gap={3}
        alignItems='center'
      >
        <Box flex={1}>
          <Box mb={2}>
            <TextInput
              source='SpotifyUrl' label='Spotify URL'
              fullWidth
            />
          </Box>

          <Box
            mt={2} display='flex'
            gap={2} flexWrap='wrap'
          >
            <Button
              variant='contained'
              color='primary'
              startIcon={<RefreshIcon />}
              onClick={handleForceRefresh}
              disabled={loading}
            >
              {loading ? 'Syncing...' : 'Force Refresh'}
            </Button>

            <Button
              variant='outlined'
              color='primary'
              startIcon={<OpenInNewIcon />}
              onClick={handleOpenSpotify}
              disabled={!spotifyUrl}

            >
              Open on Spotify
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default AlbumSpotifySection;
